import React from "react";
import { BsEyeFill } from "react-icons/bs";

function IncomeCard({ title, icon, amount, id }) {
  return (
    <>
      <div className="col-md-3 mb-3">
        <div className="card bg-dark p-2 border-warning">
          <div className="d-flex justify-content-between">
            <div className="col-md-4 bg-warning  d-flex justify-content-center align-items-center">
              {icon}
            </div>

            <div className="col-md-8 mx-2 ps-3">
              <div className="cardText">
                <h6 className="text-light fw-bold">{title}</h6>
                <h5 className="text-warning fw-bold">$ {amount}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default IncomeCard;
